<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :search="searchTerm"
            :loading="tableLoading"
        >
            <template #item.name="{ item }">
                <v-btn
                    x-small
                    :to="'/user/edit/' + item.id"
                    color="primary"
                >
                    {{ item.name }}
                    <v-icon
                        right
                        x-small
                    >
                        fas fa-edit
                    </v-icon>
                </v-btn>
            </template>
            <template #item.created_at="{ item }">
                {{ displayDate(item.created_at) }}
            </template>
        </v-data-table>
    </ItemIndex>
</template>
<script>
import formatDate from '../../../helpers/formatDate';
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';

export default {
    mixins: [ItemIndexBoilerplate],

    data() {
        return {
            indexType: 'user',
            singularName: 'User',
            pluralName: 'Users',
            responseObject: 'users',
            headers: [
                {
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text: 'Role',
                    value: 'roles[0].name'
                },
                {
                    text: 'Specialty',
                    value: 'profession.name'
                },
                {
                    text: 'Created',
                    value: 'created_at'
                }
            ]
        };
    },

    methods: {
        displayDate(date) {
            return formatDate(date);
        }
    }
};
</script>
